<template>
  <div class="exam-list">
    <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li>
            <router-link to="/luyen-tap">Luyện tập</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="ss-data">
      <div class="container-hts">
        <ExerciseExam :dataSource="dataExams" :dataPaging="dataPaging" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ExerciseExam from "./../../_components/ExerciseSubject/ExerciseExam"
import { getExamList } from './../../_api/'
import { STORE_KEY } from './../../_store/constants'

export default {
  name: 'ExamList',
  components: {
    ExerciseExam
  },
  data() {
    return {
      dataExams: [],
      dataPaging: {}
    };
  },
  computed: {
    ...mapState(STORE_KEY, ['paramsFilterExExam']),
    classId () {
      return parseInt(this.$route.params.classId)
    },
    subjectId () {
      return parseInt(this.$route.params.subjectId)
    }
  },
  created () {
    this.acSetParamFilterExam({...this.paramsFilterExExam, classId: this.classId, subjectId: this.subjectId})
  },
  watch: {
    'paramsFilterExExam': 'getExams'
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetParamFilterExam']),

    getExams () {
      // console.log('this.paramsFilterExExam', this.paramsFilterExExam);
      getExamList(this.paramsFilterExExam).then(res => {
        if (res) {
          this.dataExams = res.list
          this.dataPaging = res.paging
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
